import { render, staticRenderFns } from "./SanityCodeBlockSerializer.vue?vue&type=template&id=be89eff6&scoped=true&"
import script from "./SanityCodeBlockSerializer.vue?vue&type=script&lang=ts&"
export * from "./SanityCodeBlockSerializer.vue?vue&type=script&lang=ts&"
import style0 from "./SanityCodeBlockSerializer.vue?vue&type=style&index=0&id=be89eff6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be89eff6",
  null
  
)

export default component.exports